<template>
  <div>
    <v-col style="padding: 12px 0 !important;">
      <table class="datatable-style">
        <thead>
          <tr>
            <th
              v-for="(item, index) in table.headers"
              :key="index"
              :class="`text-${item.align}`"
            >
              {{ item.text }}
            </th>
          </tr>
        </thead>
        <tbody>
          <v-progress-linear v-if="isLoading" absolute indeterminate />
          <div
            v-for="(item, index) in items"
            :key="index"
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <tr>
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-truncate" style="width: 100%;">
                {{ item.itemName }}
              </td>
              <td>{{ item.orderQuantity }} {{ item.package }}</td>
              <td>{{ item.receiveAmount }} {{ item.package }}</td>
              <td>{{ item.unmatchAmount }} {{ item.package }}</td>
              <td>{{ item.manufacturers[0].manufacturerName }}</td>
              <td>
                {{ item.manufacturers[0].batch[0].batchNumber }}
              </td>
              <td>
                {{ item.manufacturers[0].batch[0].expiryDate }}
              </td>
              <td>
                {{ item.manufacturers[0].batch[0].receivedQuantity }}
                {{ item.manufacturers[0].packageType }}
              </td>
              <td>
                {{ item.manufacturers[0].batch[0].bonusQuantity
                }}{{ item.manufacturers[0].packageType }}
              </td>
              <td class="text-right">
                Rp {{ formatNumber(item.manufacturers[0].unitPrice || 0) }}
              </td>
              <td class="text-right">
                Rp {{ formatNumber(item.manufacturers[0].discount || 0) }}
              </td>
              <td class="text-right">
                Rp
                {{ formatNumber(item.manufacturers[0].subTotal || 0) }}
              </td>
            </tr>
            <div
              v-for="(manufacture, index2) in item.manufacturers"
              :key="index2"
            >
              <tr v-if="item.manufacturers.length > 1 && index2 !== 0">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{ manufacture.manufacturerName }}</td>
                <td>{{ manufacture.batch[0].batchNumber }}</td>
                <td>{{ manufacture.batch[0].expiryDate }}</td>
                <td>
                  {{ manufacture.batch[0].receivedQuantity }}
                  {{ manufacture.packageType }}
                </td>
                <td>
                  {{ manufacture.batch[0].bonusQuantity }}
                  {{ manufacture.packageType }}
                </td>
                <td class="text-right">
                  Rp {{ formatNumber(manufacture.unitPrice) }}
                </td>
                <td class="text-right">
                  Rp {{ formatNumber(manufacture.discount || 0) }}
                </td>
                <td class="text-right">
                  Rp
                  {{ formatNumber(manufacture.subTotal || 0) }}
                </td>
              </tr>
              <div
                v-for="(itemBatch, index3) in manufacture.batch"
                :key="index3"
              >
                <tr v-if="manufacture.batch.length > 1 && index3 !== 0">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    {{ itemBatch.batchNumber }}
                  </td>
                  <td>
                    {{ itemBatch.expiryDate }}
                  </td>
                  <td>
                    {{ itemBatch.receivedQuantity }}
                    {{ manufacture.packageType }}
                  </td>
                  <td>
                    {{ itemBatch.bonusQuantity }}
                    {{ manufacture.packageType }}
                  </td>
                </tr>
              </div>
            </div>
          </div>
        </tbody>
      </table>
    </v-col>
    <v-col cols="7" style="padding: 12px 0 !important;">
      <div class="container-upload">
        <v-row>
          <v-col
            cols="5"
            style="display: flex; flex-direction: column; gap: 0.75rem; text-align: start;"
          >
            <input
              type="file"
              id="files"
              ref="files"
              accept="image/png, image/jpeg, application/pdf"
              multiple
              v-on:change="handleFilesUpload()"
              v-show="false"
            />
            <h4>Upload Bukti Faktur</h4>
            <div
              style="display: flex; justify-content: flex-start; align-items: center; gap: 1rem;"
            >
              <v-btn
                depressed
                outlined
                color="#1976D2"
                class="text-none"
                width="125"
                style="height: 34px; "
                @click="addFiles()"
              >
                Pilih File
              </v-btn>
              <v-btn
                depressed
                class="text-none white--text"
                @click="submitFiles()"
                color="#1976D2"
                width="125"
                style="height: 34px;"
                :loading="loadingUpload"
              >
                Upload File
              </v-btn>
            </div>
            <div>
              <span>Jenis file : (.pdf), (.jpg), (.png)</span>
              <br />
              <span>Ukuran file max. 2 MB</span>
            </div>
          </v-col>
          <v-col cols="7" class="mt-2 custome-scroll">
            <div class="upload-style">
              <div
                v-for="(arr, fileIndex) in invoices.failedFiles"
                :key="'file-' + fileIndex"
              >
                <v-row
                  class="failed-upload py-2 text-left"
                  no-gutters
                  align="center"
                >
                  <v-col cols="1" class="ml-2">
                    <v-icon
                      v-if="arr.file.type.search(/.(jpeg|jpg|png)/i) !== -1"
                      color="#D32F2F"
                    >
                      mdi-file-image
                    </v-icon>
                    <v-icon
                      v-else-if="arr.file.type.search(/.pdf/i) !== -1"
                      color="#D32F2F"
                    >
                      mdi-file-pdf-box
                    </v-icon>
                    <v-icon v-else class="icon">mdi-file-code</v-icon>
                  </v-col>
                  <v-col cols="9" class="mx-2">
                    <label
                      class="text-left ma-0"
                      style="font-size: 12px; font-weight: 400; color: #616161;"
                    >
                      File
                      <span style="font-weight: 700;">
                        {{ arr.file.name }}
                      </span>
                      gagal diunggah, karena
                      <span style="color: #D32F2F;">{{ arr.message }}</span>
                    </label>
                  </v-col>
                  <v-col cols="1">
                    <button
                      class="btn-back"
                      @click="removeWarning(fileIndex, idx)"
                    >
                      <v-icon color="#757575">mdi-close</v-icon>
                    </button>
                  </v-col>
                </v-row>
              </div>
              <div
                v-for="(item, fileIndex) in invoices.files"
                class="row-upload"
                no-gutters
                align="center"
                :key="'file-' + fileIndex"
              >
                <v-icon class="icon">mdi-file-document</v-icon>
                <label class="text-left text-truncate" style="width: 100%;">
                  {{ item.name }}
                </label>
                <v-spacer />
                <v-btn
                  small
                  color="primary"
                  depressed
                  class="text-none"
                  @click="previewFile(item)"
                  outlined
                  style="min-width: 10px !important;"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
                <v-btn
                  small
                  color="error"
                  depressed
                  class="text-none"
                  icon
                  @click="removeFiles(fileIndex)"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <v-dialog v-model="dialog" width="930">
      <v-card v-if="dialog" flat>
        <v-card-title class="justify-center">
          <h3>
            Input Data Penerimaan Barang <br />
            On Hold
          </h3>
        </v-card-title>
        <v-row no-gutters class="pa-5 mx-5">
          <v-col cols="6" class="pr-4">
            <div class="input-data text-left">
              <label class="font-weight-bold body-2">Tanggal Pemesanan</label>
              <label class="body-2">{{ selectedItem.orderDate }}</label>

              <label class="font-weight-bold body-2">Nama Barang</label>
              <label class="body-2">{{ selectedItem.name }}</label>

              <label class="font-weight-bold body-2">Jumlah Pesanan</label>
              <label class="body-2">{{
                `${selectedItem.orderAmount} ${selectedItem.package || ''}`
              }}</label>

              <label class="font-weight-bold body-2">Jumlah Diterima</label>
              <label class="body-2">{{
                `${selectedItem.receiveAmount} ${selectedItem.package || ''}`
              }}</label>

              <label class="font-weight-bold body-2"
                >Jumlah Barang On <br />Hold Diterima</label
              >
              <div style="display: flex">
                <v-text-field
                  type="number"
                  placeholder="Masukkan jumlah"
                  v-model="selectedItem.inputOnHold"
                  dense
                  hide-details="false"
                  class="pr-3"
                ></v-text-field>
              </div>

              <label class="font-weight-bold body-2">Hibah</label>
              <v-radio-group
                v-model="selectedItem.hibah"
                row
                hide-details="false"
              >
                <v-radio label="Ya" :value="true"></v-radio>
                <v-radio label="Tidak" :value="false"></v-radio>
              </v-radio-group>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="input-data text-left">
              <label class="font-weight-bold body-2">Nomor Faktur</label>
              <v-text-field
                v-model="selectedItem.invoiceNumber"
                dense
                placeholder="Masukkan nomor faktur"
                :rules="rules.invoice"
              ></v-text-field>

              <label class="font-weight-bold body-2">Nomor Tanda Terima</label>
              <label class="body-2">{{ selectedItem.receiptNumber }}</label>

              <label class="font-weight-bold body-2">Tanggal Expired</label>
              <v-menu
                dense
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="dateTemp"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedItem.expiredDate"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    placeholder="Pilih Tanggal"
                    append-icon="mdi-chevron-down"
                    outlined
                    single-line
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateTemp"
                  no-title
                  scrollable
                  :min="now"
                  @input="
                    menu = false;
                    $refs.menu.save(dateTemp);
                  "
                />
                <!-- $refs.menu.save(selec  tedItem.expiredDate); -->
              </v-menu>

              <label class="font-weight-bold body-2">Nomor Batch Barang</label>
              <v-text-field
                placeholder="Masukkan Nomor Batch"
                dense
                :rules="rules.batch"
                v-model="selectedItem.batch"
              ></v-text-field>

              <label class="font-weight-bold body-2">Package</label>
              <v-autocomplete
                placeholder="Pilih Package"
                v-model="selectedItem.package"
                :items="resource.package"
                append-icon="mdi-chevron-down"
                :loading="packageLoading"
                :search-input.sync="searchPackage"
                dense
                outlined
                single-line
              ></v-autocomplete>

              <label class="font-weight-bold body-2">Selesai</label>
              <v-switch inset v-model="selectedItem.isComplete"></v-switch>
            </div>
          </v-col>
        </v-row>
        <div class="px-5 mx-5">
          <h4 class="mb-3">Riwayat Penerimaan Barang</h4>
          <!-- <v-data-table
            :headers="historyTable.headers"
            :items="historyTable.items"
            :items-per-page="5"
          ></v-data-table> -->
          <div class="history-header mb-2">
            <span class="font-weight-bold text-center">{{
              historyTable.headers[0].text
            }}</span>
            <span class="font-weight-bold text-center">{{
              historyTable.headers[1].text
            }}</span>
            <span class="font-weight-bold text-center">{{
              historyTable.headers[2].text
            }}</span>
            <span class="font-weight-bold text-left">{{
              historyTable.headers[3].text
            }}</span>
          </div>
          <div
            v-for="(item, index) in selectedItem.history"
            class="history-header"
            :key="index"
          >
            <span class="text-center">{{ `${item.created_at} WIB` }}</span>
            <span class="text-center">{{ item.received_amount }}</span>
            <span class="text-center">{{
              item.package ? item.package : '-'
            }}</span>
            <span class="text-left">{{ item.created_by }}</span>
          </div>
        </div>

        <v-card-actions class="card-footer">
          <v-btn text class="text-none" @click="dialog = false">Kembali</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            tile
            depressed
            class="text-none"
            width="150"
            @click="saveData()"
            >Simpan</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import moment from 'moment-timezone';
import Constant from '@/const';
import AlertMixin from '@/mixin/alertMixin';

const axios = require('axios');

export default {
  name: 'ReceiveDetail',
  mixins: [AlertMixin],
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    fileIdentifier: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: null,
    },
    historyData: {
      type: Array,
      default: null,
    },
    allStaff: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      dummyData: [
        {
          itemName: 'Paracetamol 5 mg (SANBE)',
          orderQuantity: '25',
          package: 'Box',
          manufacturers: [
            {
              manufacturerName: 'SANBE',
              packageType: 'Box',
              batch: [
                {
                  batchNumber: '022425034',
                  expiryDate: '15-02-2025',
                  receivedQuantity: 10,
                  bonusQuantity: 8,
                },
                {
                  batchNumber: '4994034',
                  expiryDate: '15-02-2025',
                  receivedQuantity: 20,
                  bonusQuantity: 1,
                },
              ],
              unitPrice: 10000,
              discount: 5000,
              isDiscountPercentage: false,
            },
            {
              manufacturerName: 'HEXAPHARM',
              packageType: 'Box',
              batch: [
                {
                  batchNumber: '022425034',
                  expiryDate: '15-02-2025',
                  receivedQuantity: 10,
                  bonusQuantity: 8,
                },
                {
                  batchNumber: '4994034',
                  expiryDate: '15-02-2025',
                  receivedQuantity: 20,
                  bonusQuantity: 1,
                },
              ],
              unitPrice: 10000,
              discount: 5000,
              isDiscountPercentage: false,
            },
          ],
        },
      ],
      loadingUpload: false,
      menu: false,
      dateTemp: '',
      searchPackage: '',
      packageLoading: false,
      resource: {
        package: [],
      },
      invoices: {
        files: [],
        failedFiles: [],
      },
      table: {
        headers: [
          { text: 'No', align: 'center' },
          { text: 'Nama Barang', align: 'start' },
          { text: 'Jml Pesanan', align: 'start' },
          { text: 'Jml Total Diterima', align: 'start' },
          { text: 'Jml Kurang', align: 'start' },
          { text: 'Pabrikan', align: 'start' },
          { text: 'No Batch', align: 'start' },
          { text: 'Tgl Expired', align: 'start' },
          { text: 'Jml Diterima PerBatch', align: 'start' },
          { text: 'Jml Hibah', align: 'start' },
          { text: 'Harga Satuan', align: 'end' },
          { text: 'Diskon', align: 'end' },
          { text: 'Total', align: 'end' },
        ],
        items: [],
      },
      dialog: false,
      historyTable: {
        headers: [
          { text: 'Tanggal Penerimaan', value: 'receiveDate' },
          { text: 'Jumlah Barang Diterima', value: 'receiveAmount' },
          { text: 'Satuan', value: 'unit' },
          { text: 'Nama Staff Penerima', value: 'staffName' },
        ],
        items: [],
      },
      rules: {
        batch: [v => !!v || '* Wajib Diisi'],
        invoice: [v => !!v || '* Faktur sudah digunakan'],
      },
      selectedItem: {},
      now: moment(new Date()).format('YYYY-MM-DD'),
    };
  },
  watch: {
    'selectedItem.inputOnHold'(val) {
      if (
        +val + +this.selectedItem.receiveAmount >=
        +this.selectedItem.orderAmount
      ) {
        this.selectedItem.isComplete = true;
      } else {
        this.selectedItem.isComplete = false;
      }
    },
    dateTemp(val) {
      this.selectedItem.expiredDate = moment(val, 'YYYY-MM-DD').format(
        'DD-MM-YYYY',
      );
    },
    searchPackage(val) {
      this.getPackage(val);
    },
  },
  mounted() {
    this.table.items = this.items;
    this.getPackage();
  },
  methods: {
    findStaff(id) {
      const staffName = this.allStaff.filter(staff => staff.id === id);
      return staffName[0].name;
    },
    async submitFiles() {
      if (this.invoices.files.length > 0) {
        this.loadingUpload = true;
        const formData = new FormData();

        for (let i = 0; i < this.invoices.files.length; i++) {
          const file = this.invoices.files[i];

          formData.append(`files`, file);
        }
        formData.append('identifier', this.fileIdentifier);
        formData.append('tag', 'invoicesupplier');
        formData.append('created_by', this.$store.getters.userLoggedIn.id);

        await axios
          .post(Constant.apiUrl.concat('/upload'), formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => {
            if (response) this.showFillSuccess('Berhasil Mengunggah File');
            this.invoices.files = [];
            this.$emit('get-data');
          })
          .catch(error => {
            this.showErrorAxios(error);
          })
          .finally(() => {
            this.loadingUpload = false;
          });
      } else {
        this.showFillWarning('Tidak Ada File yang Diunggah');
      }
    },
    getPackage(keyword) {
      this.packageLoading = true;
      axios
        .get(
          Constant.apiUrl.concat(
            `/master/package/menu/inventory?page=1&itemCount=&search=${keyword ||
              ''}`,
          ),
        )
        .then(res => {
          const { data } = res.data;
          this.resource.package = data.map(unit => {
            return unit.name;
          });
        })
        .catch(() => (this.resource.package = []))
        .finally(() => {
          this.packageLoading = false;
        });
    },
    onClickOnHold(item) {
      this.selectedItem = {
        ...item,
        expiredDate:
          item.expiredDate !== '-'
            ? moment(item.expiredDate, 'DD/MM/YYYY').format('DD-MM-YYYY')
            : '',
        inputOnHold: item.orderAmount - item.receiveAmount,
        isComplete: false,
      };
      this.dialog = true;
    },
    addFiles() {
      this.$refs.files.click();
    },
    handleFilesUpload() {
      const filesUploaded = this.$refs.files.files;
      for (let i = 0; i < filesUploaded.length; i++) {
        if (this.verify(filesUploaded[i]) === '') {
          this.invoices.files.push(filesUploaded[i]);
        } else {
          this.invoices.failedFiles.push({
            file: filesUploaded[i],
            message: this.verify(filesUploaded[i]),
          });
        }
      }

      this.$refs.files.value = '';
    },
    verify(file) {
      const maxSize = 2000000;
      const allowedTypes = ['image/png', 'image/jpeg', 'application/pdf'];
      if (file.size > maxSize) {
        return 'Maksimum Ukuran file 2MB';
      }

      const ext = file.name.split('.');

      if (!allowedTypes.includes(file.type)) {
        return `Tipe file .${ext[1]} tidak diperbolehkan`;
      }

      return '';
    },
    previewFile(file) {
      const url = URL.createObjectURL(file);
      window.open(url);
    },
    removeFiles(fileIndex) {
      this.invoices.files.splice(fileIndex, 1);
    },
    removeWarning(fileIndex) {
      this.invoices.failedFiles.splice(fileIndex, 1);
    },
    async saveData() {
      try {
        const response = await axios.put(
          Constant.apiUrl
            .concat('/supply/itemlist/')
            .concat(this.selectedItem.id),
          {
            amount: {
              ordered_amount: this.selectedItem.orderAmount,
              unfit_amount: this.selectedItem.unmatchAmount,
            },
            received_amount: this.selectedItem.inputOnHold,
            isComplete: this.selectedItem.isComplete,
            isHibah: this.selectedItem.hibah,
            invoice_number: this.selectedItem.invoiceNumber,
            expiry_date:
              this.selectedItem.expiredDate !== ''
                ? moment(this.selectedItem.expiredDate, 'DD-MM-YYYY').format(
                    'YYYY-MM-DD',
                  )
                : null,
            batch_number: this.selectedItem.batch,
            package: this.selectedItem.package,
            created_by: this.$store.getters.userLoggedIn.id,
          },
        );
        if (response) {
          Swal.fire('Data Penerimaan Barang Berhasil Tersimpan', '', 'success');
          this.$emit('get-data');
          this.dialog = false;
        }
      } catch (error) {
        this.showErrorAxios(error);
      }
    },
    formatNumber(num) {
      if (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',00';
      }
      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.custome-scroll {
  overflow: scroll;
  height: 11rem;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 8px;
    background-color: #ededed;
  }
  &::-webkit-scrollbar-thumb {
    width: 8px;
    border-radius: 8px;
    background-color: #9e9e9e;
  }
}
.card-footer {
  position: sticky;
  background-color: white;
  bottom: 0;
}
.failed-upload {
  background-color: #ffebee;
  border: 1px solid #ededed;
  color: #616161;
  border-radius: 5px;
}

.history-header {
  width: 100%;
  display: grid;
  grid-template-columns: 30% 20% 20% 30%;
  column-gap: 10px;
  font-size: 0.8rem;
}

.input-data {
  display: grid;
  grid-template-columns: 25vh 30vh;
  grid-template-rows: repeat(6, 8vh);
  align-items: baseline;
}
.datatable-style {
  width: 100%;
  border-spacing: 0;
  thead {
    background-color: #f5f5f5;
    tr {
      display: grid;
      grid-template-columns: 2.41fr 12.52fr 6.71fr 6.71fr 6.71fr 7.32fr 6.79fr 6.94fr 7.01fr 6.49fr 10.13fr 10.13fr 10.13fr;
      grid-template-rows: auto;
      width: 100%;
      align-items: center;
      border-bottom: 1px solid #e0e0e0;
      th {
        text-align: start;
        padding: 0.75rem 0.5rem;
        color: #9e9e9e;
        font-weight: 500;
        font-size: 12px;
      }
    }
  }
  tbody {
    tr {
      display: grid;
      grid-template-columns: 2.41fr 12.52fr 6.71fr 6.71fr 6.71fr 7.32fr 6.79fr 6.94fr 7.01fr 6.49fr 10.13fr 10.13fr 10.13fr;
      grid-template-rows: auto;
      width: 100%;
      td {
        text-align: start;
        padding: 0.75rem 0.5rem;
        color: #404040;
        font-weight: 400;
        font-size: 12px;
      }
    }
  }
}
.container-upload {
  padding: 1rem;
  width: 50vw;
  height: 12.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  h4 {
    color: #404040;
    font-size: 16px;
    font-weight: 600;
  }
  span {
    color: #404040;
    font-size: 12px;
    font-weight: 400;
  }
}

.upload-style {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .row-upload {
    padding: 0 0.5rem;
    border-radius: 4px;
    min-height: 42px;
    border: 1px solid #e0e0e0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
  }
}
</style>
